import { createFileRoute } from '@tanstack/react-router';

import CalculationEditTemplatePage from '@/areas/calculations/Calculation/Templates/EditTemplatePage/CalculationEditTemplatePage';
import { canEditCalculationTemplates } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/templates/calculation/$templateId/edit')({
    staticData: { access: { permissions: canEditCalculationTemplates }, chrome: 'home' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return <CalculationEditTemplatePage {...pathParams} />;
}
